import { useUserStore } from '@/store/modules/user'
import { sendMsg } from '@/utils'

const IDLE_TIMEOUT_MINUTES = 60
let idleTimer: any = null
let lastActivity = Date.now()

function resetIdleTimer() {
  lastActivity = Date.now()
}

function checkIdleTimeout() {
  if (Date.now() - lastActivity > IDLE_TIMEOUT_MINUTES * 60 * 1000) {
    const { reset } = useUserStore()

    clearInterval(idleTimer)
    sendMsg(false, 'Logged out automatically because of extended idle time.')
    reset()
  }
}

export function setupIdleMonitor() {
  document.addEventListener('mousemove', resetIdleTimer)
  document.addEventListener('keydown', resetIdleTimer)

  idleTimer = setInterval(checkIdleTimeout, 60 * 1000) // 每分鐘檢查一次
}
